export default __webpack_public_path__ + "static/media/register.753498d3.svg";